import { Stack } from '@fluentui/react';
import { FormHookTextField } from 'common/components/FormHooksFields';
import { useStyles } from './index.styles';

export const BasicForm = () => {
  const styles = useStyles();

  return (
    <Stack className={styles.container} tokens={{ childrenGap: 10 }}>
      <Stack horizontal tokens={{ childrenGap: 20 }} verticalAlign="center">
        <Stack className={styles.fieldContainer}>
          <FormHookTextField label="Name" name="name" required />
        </Stack>
      </Stack>
      <Stack>
        <Stack className={styles.fieldContainer}>
          <FormHookTextField
            label="Description"
            name="description"
            multiline
            rows={3}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
